import { AxiosResponse } from 'axios';
import { appContextGet, appContextPost, appContextPut } from './httpCommon/appAxios.service';
import { MARKETPLACE_PROFILE_ENDPOINTS } from '../constants/apiEndpoints';
import {
  MarketPlaceProfile,
  MarketPlaceProfileCreateRequest,
  MarketPlaceProfileUpdateRequest,
} from '../types/interfaces/marketPlace.interfaces';

const { GET_MARKETPLACE_PROFILE_ACCOUNT, MARKETPLACE_PROFILE, MARKETPLACE_PROFILE_IMAGE } = MARKETPLACE_PROFILE_ENDPOINTS;

export const getMarketplaceProfile = (accountId: number): Promise<AxiosResponse<MarketPlaceProfile>> => {
  return appContextGet(`${GET_MARKETPLACE_PROFILE_ACCOUNT}/${accountId}`);
};

export const getMarketplaceProfileExists = (accountId: number): Promise<AxiosResponse<boolean>> => {
  return appContextGet(`${GET_MARKETPLACE_PROFILE_ACCOUNT}/${accountId}/exists`);
};

export const createMarketplaceProfile = (data: MarketPlaceProfileCreateRequest): Promise<AxiosResponse<MarketPlaceProfile>> => {
  return appContextPost(MARKETPLACE_PROFILE, data);
};

export const updateMarketplaceProfile = (
  marketPlaceProfileId: number,
  data: MarketPlaceProfileUpdateRequest,
): Promise<AxiosResponse<MarketPlaceProfile>> => {
  return appContextPut(`${MARKETPLACE_PROFILE}/${marketPlaceProfileId}`, data);
};

export const uploadMarketplaceProfileImage = (accountId: number, formData: FormData): Promise<AxiosResponse<void>> => {
  return appContextPost(
    MARKETPLACE_PROFILE_IMAGE,
    formData,
    { accountId },
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
};

export const getMarketplaceProfileImage = (accountId: number): Promise<AxiosResponse<Blob>> => {
  return appContextGet(`${MARKETPLACE_PROFILE_IMAGE}/${accountId}`, undefined, {
    responseType: 'blob',
  });
};
